import _defineProperty from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production-china/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { resetComponent } from '../../style';
import { genComponentStyleHook, mergeToken } from '../../theme/internal';

var genStatisticStyle = function genStatisticStyle(token) {
  var _$concat, _Object$assign;

  var componentCls = token.componentCls,
      marginXXS = token.marginXXS,
      padding = token.padding,
      colorTextDescription = token.colorTextDescription,
      titleFontSize = token.titleFontSize,
      colorTextHeading = token.colorTextHeading,
      contentFontSize = token.contentFontSize,
      fontFamily = token.fontFamily;
  return _defineProperty({}, "".concat(componentCls), Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign = {}, _defineProperty(_Object$assign, "".concat(componentCls, "-title"), {
    marginBottom: marginXXS,
    color: colorTextDescription,
    fontSize: titleFontSize
  }), _defineProperty(_Object$assign, "".concat(componentCls, "-skeleton"), {
    paddingTop: padding
  }), _defineProperty(_Object$assign, "".concat(componentCls, "-content"), (_$concat = {
    color: colorTextHeading,
    fontSize: contentFontSize,
    fontFamily: fontFamily
  }, _defineProperty(_$concat, "".concat(componentCls, "-content-value"), {
    display: 'inline-block',
    direction: 'ltr'
  }), _defineProperty(_$concat, "".concat(componentCls, "-content-prefix, ").concat(componentCls, "-content-suffix"), {
    display: 'inline-block'
  }), _defineProperty(_$concat, "".concat(componentCls, "-content-prefix"), {
    marginInlineEnd: marginXXS
  }), _defineProperty(_$concat, "".concat(componentCls, "-content-suffix"), {
    marginInlineStart: marginXXS
  }), _$concat)), _Object$assign)));
}; // ============================== Export ==============================


export default genComponentStyleHook('Statistic', function (token) {
  var statisticToken = mergeToken(token, {});
  return [genStatisticStyle(statisticToken)];
}, function (token) {
  var fontSizeHeading3 = token.fontSizeHeading3,
      fontSize = token.fontSize;
  return {
    titleFontSize: fontSize,
    contentFontSize: fontSizeHeading3
  };
});